export const sortByCustomOrder = (array, customOrder) => {
  if (!array) {
    return [];
  }
  return array.sort(
    (a, b) => customOrder.indexOf(a.id) - customOrder.indexOf(b.id),
  );
};
